export * from './error';
export * from './user-notification-dialog';

import { ErrorComponents } from './error';
import { UserNotificationDialogComponents } from './user-notification-dialog';

export const AppCommonComponents = [
    ...ErrorComponents, ...UserNotificationDialogComponents
];